import { memo, ChangeEvent } from "react";
import { Box, Typography, RadioGroup, FormControlLabel, Radio } from "@mui/material";

// Types and Interfaces
export interface ImageTypeSelectorProps {
  imageType: string;
  setImageType: (value: string) => void;
}

const ImageTypeSelector = memo<ImageTypeSelectorProps>(({ 
  imageType, 
  setImageType 
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setImageType(event.target.value);
  };

  return (
    <Box
      sx={{
        mb: 4,
        p: 2,
        border: "1px solid #4d4d4dff",
        borderRadius: 1,
      }}
    >
      <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
      Item Images
      </Typography>

      <RadioGroup
        row
        value={imageType}
        onChange={handleChange}
        sx={{ mb: 3, ml: 2 }}
      >
        <FormControlLabel
          value="common"
          control={<Radio />}
          label="Common Images"
          sx={{
            "& .MuiRadio-root": {
              color: "#1976d2",
              "&.Mui-checked": {
                color: "#1976d2",
              },
            },
          }}
        />
        <FormControlLabel
          value="itemwise"
          control={<Radio />}
          label="Item Specific Images"
          sx={{
            "& .MuiRadio-root": {
              color: "#1976d2",
              "&.Mui-checked": {
                color: "#1976d2",
              },
            },
          }}
        />
      </RadioGroup>
    </Box>
  );
});

ImageTypeSelector.displayName = "ImageTypeSelector";

export default ImageTypeSelector;